module.exports = "<div class=\"rate-term-notification-wrapper\">\n    <equity-notification notification=\"notification\"></equity-notification>\n</div>";